import React from 'react'
import { Input } from 'loyal-react'
import PropTypes from 'prop-types'
import Individual from './Individual'
import Company from './Company'

const Profile = ({
  participant,
  errors,
  disabled,
  personalEmail,
  mobilePhone,
  isCpf,
  updateState
}) => {
  let classPhone
  isCpf ? classPhone = 'col-md-3 col-sm-6 mt-2' : classPhone = 'col-md-6 mt-2'
  return (
    <div className='row'>
      {isCpf ? (
        <Individual
          participant={participant}
          errors={errors}
          disabled={disabled}
          updateState={updateState}
        />
      ) : (
        <Company
          participant={participant}
          errors={errors}
          disabled={disabled}
          updateState={updateState}
        />
      )}
      <div className={`${classPhone}`}>
        <Input
          id='mobilePhone'
          label='Celular'
          mask={[
            '(',
            /[1-9]/,
            /\d/,
            ')',
            ' ',
            /\d/,
            /\d/,
            /\d/,
            /\d/,
            /\d/,
            '-',
            /\d/,
            /\d/,
            /\d/,
            /\d/
          ]}
          aria-required
          value={mobilePhone}
          valid={errors.mobilePhone}
          data-error='Digite um Telefone Celular válido'
          disabled={disabled.mobilePhone}
          onChange={(e) => updateState('mobilePhone', e.target.value)}
        />
      </div>
      <div className='col-md-6 mt-2'>
        <Input
          id='email'
          label='E-mail'
          value={personalEmail}
          aria-required
          data-error='Digite um E-mail válido'
          disabled={disabled.personalEmail}
          valid={errors.personalEmail}
          onChange={(e) => updateState('personalEmail', e.target.value)}
        />
      </div>
    </div>
  )
}

Profile.propTypes = {
  participant: PropTypes.object,
  errors: PropTypes.object,
  disabled: PropTypes.object,
  mobilePhone: PropTypes.string,
  personalEmail: PropTypes.string,
  isCpf: PropTypes.bool,
  updateState: PropTypes.func
}

export default Profile



// WEBPACK FOOTER //
// ./src/features/UserInfosValidation/Profile.js